import { render, staticRenderFns } from "./OrdersDetails.vue?vue&type=template&id=69914d6c"
import script from "./OrdersDetails.vue?vue&type=script&lang=js"
export * from "./OrdersDetails.vue?vue&type=script&lang=js"
import style0 from "./OrdersDetails.vue?vue&type=style&index=0&id=69914d6c&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports